import can from '@/router/middleware/can'

import auth from '../../../middleware/auth'

export default [
  {
    path: '/settings/beverages/ingredients',
    name: 'SettingsBeveragesIngredients',
    component: () =>
      import(
        /* webpackChunkName: "SettingsBeveragesIngredients" */ '@/pages/settings/beverages/ingredients/IngredientIndex'
      ),
    meta: {
      middleware: [auth, can('isIngredientsShow')],
      title: 'ingredients',
      breadCrumb: [
        { text: 'settings' },
        { text: 'beverages' },
        { text: 'ingredients' }
      ]
    }
  },
  {
    path: '/settings/beverages/units',
    name: 'SettingsBeveragesUnits',
    component: () =>
      import(
        /* webpackChunkName: "SettingsBeveragesUnits" */ '@/pages/settings/beverages/units/UnitIndex'
      ),
    meta: {
      middleware: [auth, can('isIngredientsShow')],
      title: 'units',
      breadCrumb: [
        { text: 'settings' },
        { text: 'beverages' },
        { text: 'units' }
      ]
    }
  },
  {
    path: '/settings/beverages/recipes',
    name: 'SettingsBeveragesRecipes',
    component: () =>
      import(
        /* webpackChunkName: "SettingsBeveragesRecipes" */ '@/pages/settings/beverages/recipes/RecipeIndex'
      ),
    meta: {
      middleware: [auth, can('isRecipesShow')],
      title: 'recipes',
      breadCrumb: [
        { text: 'settings' },
        { text: 'beverages' },
        { text: 'recipes' }
      ]
    }
  }
]
